import React, { useEffect, useState } from "react";
import { useProductData } from "@/zustand/productStore";
import ProductsList from "@children/components/ProductPackages/ProductsList";
import Skeleton from "@/components/ProductPackages/Skeleton";
import { useQuizModalStore } from "@/zustand/quizModalStore.js";

const productsHeading = window.post_template?.checkout_v4_products?.tr_checkout_v4_products_heading;
const ProductPackages = () => {
  const [initialLoad, setIntialLoad] = useState(true);
  const { isQuizCompleted, isQuizModalOpen } = useQuizModalStore();
  const productsData = useProductData();
  const quizShow = window.post_template?.checkout_v4_quiz.quiz_show
    ? isQuizCompleted && productsData?.products
    : productsData?.products;

  useEffect(() => {
    const element = document.getElementById(`productCard-${1}`);
    if (!element || initialLoad) return;
    setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio < 1) {
              element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
          });
        },
        {
          threshold: [0, 1],
        }
      );
      observer.observe(element);
      setTimeout(() => {
        return observer.disconnect();
      }, 310);
    }, 300);
  }, []);

  return (
    <>
      <div
        data-testid="products-label"
        className={`productPackages__heading ${window.enhancedContrast && "enhancedContrast"}`}
        id="products"
      >
        {productsHeading}
      </div>
      <div className="productPackages__wrapper">
        {quizShow ? (
          <ProductsList
            bundles={productsData?.show_bundle_design}
            pickerV2={productsData?.show_product_picker_v2}
            subscription={productsData?.subscription?.subscription_enable}
          />
        ) : (
          <Skeleton />
        )}
      </div>
    </>
  );
};

export default ProductPackages;
